import { resolveShipToSubscribers } from "@bcc/lib/products/ship-to-countries";
import { useVendorContext } from "@client-shared/providers/vendor";
import { CellContext } from "@tanstack/react-table";
import { setSubscribersCellTestId } from "../products-table.utils";
import { VariantWithProductData } from "../types";

export const SubscribersCellMarkup = (props: CellContext<VariantWithProductData, unknown>) => {
  const data = props.row.original;
  const [{ currentVendor }] = useVendorContext();

  // Cross-border SKUs carry a per-country subscriber count in `shipToInfo`.
  // Resolve the logged-in vendor's own country entry (mirrors
  // WeeklyLimitCellMarkup/MsrpRrpCellMarkup) rather than an arbitrary index,
  // falling back to the flat field for non-cross-border rows.
  const subscribers = resolveShipToSubscribers(data.shipToInfo, currentVendor?.countryCode, data.activeSubscriberCount ?? 0);

  return (
    <span className="text-sm font-medium" data-testid={setSubscribersCellTestId(props.row.index)}>
      {subscribers}
    </span>
  );
};
